import { isIE, isEdge } from 'react-device-detect';

export default function dynamicImport() {
    let packages = [];
    if (isIE || isEdge) {
        packages.push(
            import(
                /* webpackChunkName: "ie-patch-date-time-format-timezone" */ 'date-time-format-timezone'
            )
        );
    }
    return Promise.all(packages);
}
